import { z } from 'zod';

export const confirmPasswordSchema = z.object({
    password: z.string(),
    confirmPassword: z.string(),
  }).refine(data => data.password === data.confirmPassword, {
    path: ['confirmarSenha'],
    message: 'As senhas não correspondem',
  });

//   export const checkPasswordSchema = z.object({
//     senha: z.string()
//       .min(6, '6 caracteres')
//       .refine(val => /[a-z]/.test(val), { message: 'letra minuscula' })
//       .refine(val => /[A-Z]/.test(val), { message: 'letra maiuscula' })
//       .refine(val => /\d/.test(val), { message: 'um numero' })
//       .refine(val => /[@$!%*?&]/.test(val), { message: 'caractere especial' }),
//   });

// Schema básico para a senha
export const basePasswordSchema = z.object({
    senha: z.string()
      .min(6, { message: '6 caracteres' })
      .refine(val => /[a-z]/.test(val), { message: 'letra minuscula' })
      .refine(val => /[A-Z]/.test(val), { message: 'letra maiuscula' }),
  });
  
  // Schema para verificar se há um número
  export const numberSchema = basePasswordSchema.extend({
    senha: z.string().refine(val => /\d/.test(val), { message: 'um numero' }),
  });
  
  // Schema para verificar se há um caractere especial
  export const specialCharSchema = basePasswordSchema.extend({
    senha: z.string().refine(val => /[@$!%*?&]/.test(val), { message: 'caractere especial' }),
  });